<template>
    <modal
        name="cancel-subscription"
        :classes="'customModal'"
        :scrollable="true"
        :reset="true"
        :adaptive="false"
        :width="650"
        height="auto"
        @before-open="getData"
    >
        <div class="modalWrapper">
            <div class="content__box">
                <div class="content__box__body mb-4">
                    <h2 class="txt--fslg pb-1"> Cancel Subscription </h2>
                    <div class="form-row mt-3 align-items-center">
                        <div class="col-lg-12 mb-4">
                            <app-toggle
                                :key="toggle_key"
                                :checked="selected_option == 'now' ? true : false"
                                @update:checked="checkUncheck($event, 'now')"
                                :label="'Cancel Now'"
                            ></app-toggle>
                        </div>
                        <div class="col-lg-12 mb-4">
                            <app-toggle
                                :key="toggle_key"
                                :checked="selected_option == 'period_end' ? true : false"
                                @update:checked="checkUncheck($event, 'period_end')"
                                :label="'Cancel Later'"
                            ></app-toggle>
                        </div>
                        <div class="col-lg-6 mb-4">
                            <app-toggle
                                :key="toggle_key"
                                :checked="selected_option == 'cancel_custom'? true : false"
                                @update:checked="checkUncheck($event, 'cancel_custom')"
                                :label="'Cancel On Custom Date'"
                            ></app-toggle>
                        </div>
                        <div class="col-lg-6 mb-4" v-if="selected_option== 'cancel_custom'">
                            <datetime
                                title="Custom Cancellation Date"
                                input-id="cancel_date"
                                class="dateTime__picker"
                                format="yyyy-MM-dd hh:mm a"
                                type="datetime"
                                :input-class="['textInputField']"
                                :min-datetime="today"
                                :zone="property_timezone"
                                :value-zone="property_timezone"
                                v-tooltip="property_timezone"
                                v-model="custom_date"
                                :clear-button="true"
                            >
                            </datetime>
                        </div>
                        <div class="col-lg-8 mb-4">
                            <div class="col-lg-8 mb-1 txt-ss text-white-50">
                                Reason for canceling
                            </div>
                            <textarea style="resize: none; width: 100%; height: 80px; padding: 8px; font-size: 14px; background: black; color: grey;" class="" v-model="cancel_reason" ></textarea>
                        </div>
                        <div class="col-lg-12 mb-4">
                            <app-toggle
                                :checked="cancel_all"
                                :label="'Cancel All Permits'"
                                @update:checked="checkCancelAll($event)"
                                v-tooltip="'This will apply the cancellation to all the permit subscriptions of this user.'"
                            ></app-toggle>
                        </div>
                        <div class="col-lg-12 mb-4">
                            <app-toggle
                                :checked="notify_user"
                                :label="'Notify User'"
                                @update:checked="checkNotifyUser($event)"
                            ></app-toggle>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-row">
                <div class="col-12">
                    <div class="d-flex justify-content-center flex-wrap">
                        <ButtonWithSpinner
                        class="button button--primary button--sm mr-3"
                        :loading="button.loading"
                        :success="button.success"
                        :disabled="button.disabled"
                        @click="submitDetails"
                        >Save</ButtonWithSpinner
                        >
                        <button
                        type="button"
                        class="button button--outline button--sm"
                        @click="closeModal()"
                        >
                        Cancel
                        </button>
                    </div>
                </div>
            </div>
            <div class="session__modal__close" @click="closeModal()">
                <i class="fas fa-times"></i>
            </div>
        </div>
    </modal>
</template>
<script>
import Toggle from "@/components/toggle";
import ButtonWithSpinner from "@/components/Button";
import { Datetime } from "vue-datetime";
export default {
    components: {
        ButtonWithSpinner,
        AppToggle: Toggle,
        datetime: Datetime,
    },
    data() {
        return {
            property_timezone: '',
            application_id: '',
            selected_option: null,
            custom_date: null,
            cancel_all: false,
            notify_user: true,
            toggle_key: new Date().getTime(),
            today: this.$moment().format("YYYY-MM-DDTHH:mm:ss.sssZ"),
            button: {
                loading: false,
                success: false,
                disabled: false
            },
            cancel_reason:  '',
            cancelled_by:   ''
        }
    },
    methods: {
        reset(){
            this.property_timezone = ''
            this.cancel_reason      = ''
            this.cancelled_by       = ''
            this.application_id= '',
            this.selected_option= null,
            this.custom_date= null,
            this.cancel_all= false,
            this.notify_user = false,
            this.toggle_key= new Date().getTime(),
            this.today= this.$moment().format("YYYY-MM-DDTHH:mm:ss.sssZ"),
            this.button= {
                loading: false,
                success: false,
                disabled: false
            }
        },
        getData(e) {
            this.application_id = e.params.application_id;
            this.property_timezone = e.params.property_timezone;
        },
        closeModal() {
            this.$modal.hide('cancel-subscription');
            this.$emit('api-response', {
                cancelled: false,
                selected_option: '',
                end_date: '',
            })
            this.reset();
        },
        checkUncheck(checked, cancellation_type) {
            // console.log(cancellation_type);
            if(checked) {
                this.selected_option = cancellation_type;
            }
            else {
                this.selected_option = null;
            }
            this.toggle_key += 1;
        },
        checkCancelAll(checked) {
            if (checked) {
                this.cancel_all = true;
            }
            else {
                this.cancel_all = false;
            }
        },
        checkNotifyUser(checked) {
            if (checked) {
                this.notify_user = true;
            }
            else {
                this.notify_user = false;
            }
        },
        submitDetails() {
            if(this.selected_option == null || this.selected_option =='') {
                this.$toasted.show("Please select an option before cancelling a subscription!",{
                    icon: 'times-circle',
                    className: 'error-class'
                });
                return;
            }

            if(this.selected_option == 'cancel_custom' && this.custom_date=='') {
                this.$toasted.show("Please select a custom date to cancel the subscription!",{
                    icon: 'times-circle',
                    className: 'error-class'
                });
                return;
            }

            const self = this;
            // console.log(this.selected_option);
            let message = '';
            if(this.selected_option == 'cancel_custom'){
               message = "Do you want to schedule this subscription for cancellation?";
            }
            else if(this.selected_option == 'period_end'){
               message = "Do you want to cancel this subscription in later?";
            }
            else{
                message = "Do you want to cancel this subscription?";
            }
            this.$swal({
                title: "Are you sure?",
                text: message,
                showCancelButton: true,
            }).then((result) => {
                if (result.value) {
                self.cancelSubscriptionAPIcall();
                }
            });
        },
        cancelSubscriptionAPIcall() {
            if(localStorage.getItem('admin_id') != '' && localStorage.getItem('admin_id') != null && localStorage.getItem('admin_id') != undefined)
            {
                this.cancelled_by   = localStorage.getItem('admin_id');
            }
            else if(localStorage.getItem('user_id') != '' && localStorage.getItem('user_id') != null && localStorage.getItem('user_id') != undefined)
            {
                this.cancelled_by   = localStorage.getItem('user_id');
            }

            this.button.loading = true;

            this.axios
                .post(window.hostname + "/api/auth/permit/cancel", {
                    cancel_reason:  this.cancel_reason,
                    cancelled_by:   this.cancelled_by,
                    application_id: this.application_id,
                    cancel_time: this.selected_option,
                    custom_date: this.selected_option== 'cancel_custom' ? this.$moment(this.custom_date).utc().format() : null,
                    cancel_all: this.cancel_all ? true : false,
                    notify_user: this.notify_user ? true : false,
                })
                .then(res=> {
                    this.button.loading = false;
                    if(res.data.status) {
                        this.button.success = true;
                        if(this.selected_option == 'cancel_custom'){
                            this.$toasted.show('Cancellation for subscription is scheduled successfully', {
                                icon: 'check-circle',
                                className: 'success-class'
                            }); 
                        }
                        else{
                            this.$toasted.show(res.data.message, {
                                icon: 'check-circle',
                                className: 'success-class'
                            });
                        }

                        this.$emit('api-response', {
                            cancelled: true,
                            selected_option: this.selected_option,
                            cancell_all: this.cancel_all,
                            end_date: res.data.end_date
                        });
                        this.closeModal();
                        this.reset();
                    }
                    else {
                        this.$toasted.show(res.data.message, {
                            icon: 'times-circle',
                            className: 'error-class'
                        });
                    }
                })
                .catch(err=> {
                    this.button.loading = false;
                    this.$toasted.show(err.response.data.message, {
                        icon: 'times-circle',
                        className: 'error-class'
                    });
                })
        }
    }
}
</script>